import { cn } from '@/lib/utils/cn';

/**
 * A vendor-contract milestone the contract names as an IV&V checkpoint,
 * gate or review point (E19 / T-0218, product rule 1). A plain chip in ink
 * tones, like the party chip: it is a fact about the milestone, not an AI
 * surface and not a provenance marker. Rendered on milestone rows wherever
 * milestones are listed, and next to a tied gate in a checkpoint's linked
 * deliverables.
 */
export function IvvGateChip({ className }: { className?: string }) {
  return (
    <span
      data-ivv-gate=""
      title="Named as an IV&V gate in the vendor contract"
      className={cn(
        'inline-flex h-[22px] flex-none items-center whitespace-nowrap rounded-full bg-ink-100 px-2.5 text-[12px] font-medium leading-[18px] text-ink-700',
        className,
      )}
    >
      IV&V gate
    </span>
  );
}
